import ApiService from "../../../ApiService";

const HomeworkDetailsService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/homeworkdetails/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    searchStudent: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/homeworkdetails/searchstudent", { searchVO }, successCallback, failureCallback);
    },
    sendReminder: (emailDetail, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/homeworkdetails/sendreminder", emailDetail, successCallback, failureCallback);
    },
};

export default HomeworkDetailsService;